import styled from '@emotion/styled';
import { Label, LabelContainer } from '@kc-console/common-ui';

import { ScrollObserverEntryWrapper } from '../../ScrollObserverWrapper';

import type { PropsWithChildren, ReactNode } from 'react';
import type { LabelContainerActions, LabelProps } from '@kc-console/common-ui';

interface FormGroupContainerProps extends PropsWithChildren {
  title: string;
  description?: ReactNode;
  expandable?: LabelProps['expandable'];
  formId?: string;
  htmlFor?: string;
  info?: ReactNode;
  labelActions?: LabelContainerActions;
  numberIndex?: LabelProps['numberIndex'];
  refetch?: LabelProps['refetch'];
  required?: boolean;
}

const FormGroupContainer = ({
  formId = '',
  title,
  description,
  htmlFor,
  children,
  required,
  info,
  labelActions,
  numberIndex,
  refetch,
  expandable,
}: FormGroupContainerProps) => {
  return (
    <ScrollObserverEntryWrapper
      entryId={formId}
      targetComponent={
        <FormGroupContainerRoot>
          <LabelContainer
            label={
              <Label
                label={title}
                size="lg"
                htmlFor={htmlFor}
                description={description}
                required={required}
                info={info}
                numberIndex={numberIndex}
                refetch={refetch}
                expandable={expandable}
              />
            }
            actions={labelActions}
          />
          <FormGroupContainerChildren>{children}</FormGroupContainerChildren>
        </FormGroupContainerRoot>
      }
    />
  );
};

const FormGroupContainerRoot = styled('section')`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const FormGroupContainerChildren = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export default FormGroupContainer;
